const LOADACCEPTEDPITCHES = 'twineApp/managePitches/LOADACCEPTEDPITCHES';
const LOADACCEPTEDPITCHES_SUCCESS =
  'twineApp/managePitches/LOADACCEPTEDPITCHES_SUCCESS';
const RELOADACCEPTEDPITCHES_SUCCESS =
  'twineApp/managePitches/RELOADACCEPTEDPITCHES_SUCCESS';
const LOADACCEPTEDPITCHES_FAIL =
  'twineApp/managePitches/LOADACCEPTEDPITCHES_FAIL';

const initialState = {
  acceptedPitches: [],
  acceptedPitchesTotal: 0,
  acceptedPitchesLoadMore: false,
  acceptedPitchesPagesLoaded: 0,
  loadingAcceptedPitches: false,
  loadedAcceptedPitches: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOADACCEPTEDPITCHES:
      return {
        ...state,
        loadingAcceptedPitches: true,
      };

    case LOADACCEPTEDPITCHES_SUCCESS:
      return {
        ...state,
        loadingAcceptedPitches: false,
        loadedAcceptedPitches: true,
        acceptedPitches:
          typeof action.result.threads === 'undefined'
            ? state.acceptedPitches
            : state.acceptedPitches.concat(action.result.threads),
        acceptedPitchesTotal:
          typeof action.result.threads === 'undefined'
            ? state.acceptedPitchesTotal
            : action.result.meta.pagination.total,
        acceptedPitchesLoadMore:
          typeof action.result.threads === 'undefined'
            ? false
            : action.result.meta.pagination.current_page <
              action.result.meta.pagination.total_pages,
        acceptedPitchesPagesLoaded: state.acceptedPitchesPagesLoaded + 1,
      };

    case RELOADACCEPTEDPITCHES_SUCCESS:
      return {
        ...state,
        loadingAcceptedPitches: false,
        loadedAcceptedPitches: true,
        acceptedPitches: action.result.threads ? action.result.threads : [],
        acceptedPitchesTotal: action.result.threads
          ? action.result.meta.pagination.total
          : 0,
        acceptedPitchesLoadMore: action.result.threads
          ? action.result.meta.pagination.current_page <
            action.result.meta.pagination.total_pages
          : false,
        acceptedPitchesPagesLoaded: 1,
      };

    case LOADACCEPTEDPITCHES_FAIL:
      return {
        ...state,
        loadingAcceptedPitches: false,
      };

    default:
      return state;
  }
}

export function loadAcceptedPitches(userId, page) {
  return {
    types: [
      LOADACCEPTEDPITCHES,
      LOADACCEPTEDPITCHES_SUCCESS,
      LOADACCEPTEDPITCHES_FAIL,
    ],
    promise: (client) =>
      client.get(
        '/users/' +
          userId +
          '/pitches?include=message.notice,message.notice.user,message.notice.user.avatars&state=accepted&page=' +
          page
      ),
  };
}

export function reloadAcceptedPitches(userId, page) {
  return {
    types: [
      LOADACCEPTEDPITCHES,
      RELOADACCEPTEDPITCHES_SUCCESS,
      LOADACCEPTEDPITCHES_FAIL,
    ],
    promise: (client) =>
      client.get(
        '/users/' +
          userId +
          '/pitches?include=message.notice,message.notice.user,message.notice.user.avatars&state=accepted&page=' +
          page
      ),
  };
}
